/**
 * @module Widget
 */

import { Component, Input } from '@angular/core';
import { WidgetLayersClass } from '@class/widgetLayers.class';
import { UID } from '@models/uid.model';
import { ItemColor } from '@functions/item.functions';

@Component({
  selector: 'app-widget-layers-max',
  templateUrl: './widget-layers-max.component.html',
  styleUrls: ['./widget-layers-max.component.css']
})
export class WidgetLayersMaxComponent {

  @Input() widgetLayers: WidgetLayersClass;
  @Input() current: UID;

  color = ItemColor('widgets');

  constructor() {}

  receiveValue(value: number) {
    this.widgetLayers.layer(this.current).change({ gaugeMax: value });
    if(this.widgetLayers.uid.value === this.current) this.widgetLayers.duplicateLayersOptions({ gaugeMax: value }, this.current);
  }

}
